import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { teacherNeedsOnboarding } from "../utils/teacherOnboarding";
import { isBursarUser, isLibrarianUser, showsTeachingPortal } from "../utils/staffRoles";

function isBursarFinancePath(path) {
    return path.includes("/Teacher/fees") || path.includes("/Teacher/expenses");
}

function isLibrarianLibraryPath(path) {
    return path.startsWith("/Teacher/library");
}

function isTeachingPortalPath(path) {
    return (
        path.startsWith("/Teacher/class") ||
        path.startsWith("/Teacher/marks-entry") ||
        path.startsWith("/Teacher/attendance-entry") ||
        path.startsWith("/Teacher/results") ||
        path.startsWith("/Teacher/schemes") ||
        path.startsWith("/Teacher/lessons") ||
        path.startsWith("/Teacher/assignments") ||
        path.startsWith("/Teacher/resources") ||
        path.startsWith("/Teacher/analytics") ||
        path.startsWith("/Teacher/timetable") ||
        path.startsWith("/Teacher/leave") ||
        path.startsWith("/Teacher/my-class") ||
        path.startsWith("/Teacher/enroll-student") ||
        path.startsWith("/Teacher/form-teacher-results") ||
        path.startsWith("/Teacher/report-card") ||
        path.startsWith("/Teacher/disciplinary")
    );
}

/**
 * Blocks teacher portal routes until profile is complete and a real email is set.
 * Bursars may use finance screens during onboarding; everyone can reach profile and logout.
 */
const TeacherProfileGate = ({ children }) => {
    const { currentUser } = useSelector((state) => state.user);
    const location = useLocation();

    if (!teacherNeedsOnboarding(currentUser)) {
        return children;
    }

    const path = location.pathname;
    const librarianWithTeaching = isLibrarianUser(currentUser) && showsTeachingPortal(currentUser);
    const allowed =
        path.includes("/Teacher/profile") ||
        path.endsWith("/logout") ||
        path.includes("/logout") ||
        (isBursarUser(currentUser) && isBursarFinancePath(path)) ||
        (isLibrarianUser(currentUser) && isLibrarianLibraryPath(path)) ||
        (librarianWithTeaching && isTeachingPortalPath(path));

    if (allowed) {
        return children;
    }

    return <Navigate to="/Teacher/profile" replace state={{ from: location.pathname }} />;
};

export default TeacherProfileGate;
